import { apiRoutes } from 'constant';

import { getOrCached, put } from './http';

export const fetchRequest = () => getOrCached(apiRoutes.EMPLOYER);

export const changePassword = (oldPassword, newPassword) =>
  put(apiRoutes.UPDATE_PASSWORD, { oldPassword, newPassword });
